import { Injectable, Inject, InjectionToken } from '@angular/core';
import { from, Observable } from 'rxjs';
import { ExternalDocument, ExternalDocSearchInfo } from 'estensa-module';

export const ESTENSA_MODULE_EXTERNAL_DOCS_SERVICE = new InjectionToken('estensa.module.external.docs.service');

@Injectable({
    providedIn: 'root',
})
export class EstensaExternalDocsService {

    constructor(
        @Inject(ESTENSA_MODULE_EXTERNAL_DOCS_SERVICE) private ExternalDocsService
    ) {
        this.ExternalDocsService.initDictionaries();
    }

    loadPatientExternalDoc(idPatient: string) { // serve che sia inizializzato SOLO la proprietà Id
        return from(this.ExternalDocsService.loadPatientExternalDoc({id: idPatient}).$promise);
    }

    uploadExternalDoc(externalDocument: ExternalDocument, displayMessage: boolean = true): Observable<any> {
        return from(this.ExternalDocsService.uploadExternalDoc(externalDocument, /*displayLoadingSpinner*/ false, /*disableErrorMsgBoxOnClient*/ displayMessage).$promise);
    }

    uploadExternalDocList(externalDocumentList: ExternalDocument[]) {
        return from(this.ExternalDocsService.uploadExternalDocList(externalDocumentList).$promise);
    }

    removePatientExternalDoc(externalDocument: ExternalDocument) {
        return from(this.ExternalDocsService.removePatientExternalDoc(externalDocument, /*displayLoadingSpinner*/ false, /*disableErrorMsgBoxOnClient*/ true).$promise);
    }

    updatePatientExternalDoc(externalDocument: ExternalDocument) {
        return from(this.ExternalDocsService.updatePatientExternalDoc(externalDocument, /*displayLoadingSpinner*/ false, /*disableErrorMsgBoxOnClient*/ true).$promise);
    }

    loadExamExternalDoc(exams: string[]) {
        return from(this.ExternalDocsService.loadExamExternalDoc(exams).$promise);
    }

    removeExamExternalDoc(externalDocument: ExternalDocument, displayMessage: boolean = true) {
        return from(this.ExternalDocsService.removeExamExternalDoc(externalDocument, /*displayLoadingSpinner*/ false, /*disableErrorMsgBoxOnClient*/ displayMessage).$promise);
    }

    updateExamExternalDoc(externalDocument: ExternalDocument, displayMessage: boolean = true) {
        return from(this.ExternalDocsService.updateExamExternalDoc(externalDocument, /*displayLoadingSpinner*/ false, /*disableErrorMsgBoxOnClient*/ displayMessage).$promise);
    }

    loadAllExternalDocs(searchInfo: ExternalDocSearchInfo) {
        return from(this.ExternalDocsService.loadAllExternalDocs(searchInfo, /*displayLoadingSpinner*/ false, /*disableErrorMsgBoxOnClient*/ true).$promise);
    }

    getDocTypeDescription(id) {
        return this.ExternalDocsService.getDocTypeDescription(id);
    }

    getFileTypeDescription(id) {
        return this.ExternalDocsService.getFileTypeDescription(id);
    }
}
